import { ethers } from 'ethers';
import { getState } from 'src/store';
import { getProvider } from '../wallet';

// Public Base Sepolia RPCs cap eth_getLogs block ranges (drpc: <10k blocks,
// sepolia.base.org: 2k), so page the query in chunks.
const LOGS_CHUNK_SIZE = 9000;

export const queryLogs = async (
  address: string,
  eventDeclaration: string,
  indexed: (string | null)[],
  fromBlock: number,
) => {
  getState().setLoadingText(`Fetching on-chain data...`);
  const provider = getProvider();
  const latest = await provider.getBlockNumber();
  const logs: ethers.Log[] = [];
  for (let start = fromBlock; start <= latest; start += LOGS_CHUNK_SIZE) {
    const end = Math.min(start + LOGS_CHUNK_SIZE - 1, latest);
    logs.push(
      ...(await provider.getLogs({
        address,
        topics: [ethers.id(eventDeclaration), ...indexed],
        fromBlock: start,
        toBlock: end,
      })),
    );
  }
  getState().setLoadingText(``);
  return logs;
};
